import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductService } from '../../../../services/product.service';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { GenericFormComponent } from '../../../../shared/components/generic-crud/generic-form/generic-form.component';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { Paginator } from '../../../../models/Paginator';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { ProductTransitionsComponent } from '../product-transitions/product-transitions.component';
import { ProductPriceListsComponent } from '../product-price-list/product-price-list.component';

@Component({
  selector: 'app-product-details',
  standalone: true,
  imports: [CommonModule, FormsModule, GenericCrudComponent, GenericFormComponent, ProductTransitionsComponent, ProductPriceListsComponent],
  templateUrl: './product-details.component.html',
  styleUrl: './product-details.component.css'
})
export class ProductDetailsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private productService: ProductService
  ) {
    const navItem = this.router.getCurrentNavigation()?.extras?.state?.['item'];
    if (navItem?.name) {
      const productId = this.route.snapshot.paramMap.get('id');
      this.breadcrumbService.setBreadcrumb({
        display_name: navItem.name,
        url: `/dashboard/productos/${productId}`,
        items: [
          { name: 'Productos', url: '/dashboard/productos' },
          { name: navItem.name, url: `/dashboard/productos/${productId}` }
        ]
      });
    }
  }

  ngOnInit(): void {
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProductData();
    }
  }

  loadProductData(): void {
    if (!this.productId) return;

    this.isLoading = true;

    this.productService.getProduct(this.productId).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.productData = response.data;
          // El breadcrumb se actualiza automáticamente por el sistema de rutas
          // Solo actualizamos el nombre del producto si es necesario
          if (this.productData.name) {
            this.breadcrumbService.setBreadcrumb({
              display_name: this.productData.name,
              url: `/dashboard/productos/${this.productId}`,
              items: [
                { name: 'Productos', url: '/dashboard/productos' },
                { name: this.productData.name, url: `/dashboard/productos/${this.productId}` }
              ]
            });
          }
          
          this.initializeExamsCrud();
          this.initializeProductForm();
          this.initializeCoursesCrud();
        } else {
          console.error('Error al cargar el producto:', response.message);
          this.productData = null;
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error en la petición:', error);
        this.productData = null;
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
        this.initializeExamsCrud();
      }
    });
  }

  lessonIndexTab = 0;

  activeTabIndex = 0;


  get detailsTabs() {
    const tabs = [
      { label: 'Información General', icon: 'info' },
      { label: 'Exámenes', icon: 'document-text' },
      { label: 'Cursos', icon: 'academic-cap' },
      { label: 'Tarifas', icon: 'currency-euro' },
      { label: 'Transiciones de Estado', icon: 'arrows-right-left' },
    ];

    return tabs;
  }

  productData: any = null;
  examData: any[] = [];
  courseData: any[] = [];
  branchData: any[] = [];

  isLoading = false;
  productId: string | null = null;

  // Formulario de edición
  activeProductForm: boolean = false;
  productForm!: GenericForm;

  tableColumns: GenericTableColumn[] = [
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Tipo', active: true, type: 'text', key: 'type', sort: true },
    { name: 'Subtipo', active: true, type: 'text', key: 'proof_subtype.name', sort: false },
    { name: 'Tasas', active: true, type: 'currency', key: 'rates_price', sort: false },
    { name: 'Descripción', active: true, type: 'text', key: ['description'], sort: false },
  ];

  coursesTableColumns: GenericTableColumn[] = [
    { name: 'Código', active: true, type: 'text', key: 'code', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Tipo', active: true, type: 'text', key: 'type', sort: true },
    { name: 'Tasas', active: true, type: 'currency', key: 'rates_price', sort: false },
    { name: 'Prácticas a Añadir', active: true, type: 'text', key: 'practices_to_add', sort: false },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Edad Mínima', active: true, type: 'text', key: 'minimum_age', sort: false },
  ];

  examFormFields: GenericFormField[] = [
    { name: 'proof_definition_ids', type: 'select', label: 'Exámenes', validations: 'required', url: '/config/proof-definition/listAll', singleSelection: false },
  ];

  coursesFormFields: GenericFormField[] = [
    { name: 'course_ids', type: 'select', label: 'Curso', validations: 'required', url: '/config/course/listAll', singleSelection: false },
    { name: 'practices_to_add', type: 'number', label: 'Prácticas a Añadir', validations: 'required|min:0' },
  ];

  coursesFormFieldsEdit: GenericFormField[] = [
    { name: 'practices_to_add', type: 'number', label: 'Prácticas a Añadir', validations: 'required|min:0' },
  ];


  examsTableActions: GenericTableAction[] = [];
  coursesTableActions: GenericTableAction[] = [];
  productFormFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre del Producto', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'offices', type: 'select', label: 'Sucursales', validations: 'nullable', url: '/config/office/listAll', singleSelection: false, labelKey: 'name' },
    { name: 'company_id', type: 'select', label: 'Sociedad', validations: 'nullable', singleSelection: true, labelKey: 'name', fieldListener: 'offices', subfieldListener: 'companies' },
    { name: 'template_id', type: 'select', label: 'Plantilla', validations: 'nullable', url: '/template/listAll', singleSelection: true, labelKey: 'name' },
  ];

  tableActions: GenericTableAction[] = [];

  table!: GenericTable<Paginator<any>>;
  examForm!: GenericForm;

  genericCRUD!: GenericCRUD<Paginator<any>>;
  coursesCRUD!: GenericCRUD<any>;


  get currentTabLabel(): string {
    return this.detailsTabs[this.activeTabIndex]?.label;
  }

  getUniqueLicenses(): string[] {
    const licenses = new Set<string>();

    const courses = this.productData?.courses || this.productData?.course || [];
    courses.forEach((course: any) => {
      if (course.license?.name) {
        licenses.add(course.license.name);
      }
    });

    return Array.from(licenses);
  }

  getUniqueOffices(): any[] {
    if (!this.productData?.offices) return [];

    const officeMap = new Map();

    this.productData.offices.forEach((office: any) => {
      const officeId = office.id;

      if (officeMap.has(officeId)) {
        const existingOffice = officeMap.get(officeId);
        if (office.companies) {
          existingOffice.companies = [...(existingOffice.companies || []), ...(office.companies || [])];
          const uniqueCompanies = existingOffice.companies.filter((company: any, index: number, self: any[]) =>
            index === self.findIndex((c: any) => c.id === company.id)
          );
          existingOffice.companies = uniqueCompanies;
        }
      } else {
        officeMap.set(officeId, { ...office });
      }
    });

    return Array.from(officeMap.values());
  }

  getOfficeDisplayName(office: any): string {
    if (office.companies && office.companies.length > 0) {
      const companyNames = office.companies.map((company: any) => company.name).join(', ');
      return `${office.name} (${companyNames})`;
    }

    return office.name;
  }

  private initializeExamsCrud(): void {
    if (!this.productId) return;

    this.tableActions = [
      {
        name: 'Eliminar',
        key: 'delete',
        method: 'POST',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>`,
        confirmation: true,
        questionText: '¿Desea eliminar este examen del producto?',
        deleteRowOnResponse: true,
        actionSlug: `/product/remove-proof-definition/${this.productId}/{{id}}`,
      }
    ];

    this.table = {
      columns: this.tableColumns,
      items: [],
      type: 'generic',
      loadItemsSlug: '/product/proof-definitions/' + this.productId,
      paginate: true,
      name: 'examenes',
      actions: this.tableActions,
      details: false
    };

    this.examForm = {
      successTitle: 'Examen asignado correctamente',
      errorTitle: 'Error al asignar examen',
      method: 'POST',
      fields: this.examFormFields,
      name: 'examen',
      createButtonTitle: 'Agregar Examen',
      cols: 1,
      createApiSlug: '/product/assign-proof-definition/' + this.productId,
      formTitle: 'Asignar Examen',
      formButtonTitle: 'Asignar',
      width: '2xl'
    };

    this.genericCRUD = {
      genericForm: this.examForm,
      genericTable: this.table,
      useModalForm: true
    };
  }

  private initializeProductForm(): void {
    if (!this.productId) return;

    this.productForm = {
      successTitle: 'Producto actualizado correctamente',
      errorTitle: 'Error al actualizar producto',
      method: 'PUT',
      fields: this.productFormFields,
      name: 'producto',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      originalUpdateApiSlug: '/product/update/{{id}}',
      updateApiSlug: `/product/update/${this.productId}`,
      originalFormTitle: '',
      formTitle: '',
      formButtonTitle: 'Actualizar Producto',
      width: '4xl'
    };
  }


  private initializeCoursesCrud(): void {
    // Cursos
    this.coursesTableActions = [
      {
        name: 'Editar',
        key: 'edit',
        form: {
          method: 'PUT',
          successTitle: 'Curso actualizado correctamente',
          errorTitle: 'Error al actualizar el curso',
          fields: this.coursesFormFieldsEdit,
          name: 'curso',
          createButtonTitle: '',
          cols: 1,
          createApiSlug: '',
          originalUpdateApiSlug: `/product/update-course/${this.productId}/{{id}}`,
          updateApiSlug: '',
          originalFormTitle: 'Editar prácticas para {{name}}',
          formTitle: '',
          formButtonTitle: 'Actualizar',
          width: '2xl'
        },
        completeForm: true,
        replaceAllRowOnResponse: true,
        icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7h-1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"/><path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97l-8.415 8.385v3h3l8.385-8.415z"/><path d="M16 5l3 3"/></svg>',
        confirmation: false
      },
      {
        name: 'Eliminar curso',
        key: 'delete',
        method: 'DELETE',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
        confirmation: true,
        questionText: '¿Desea eliminar este curso del producto?',
        deleteRowOnResponse: true,
        actionSlug: `/product/remove-course/${this.productId}/{{id}}`,
      }
    ];

    const coursesForm: GenericForm = {
      successTitle: 'Curso agregado correctamente',
      errorTitle: 'Error al agregar curso',
      method: 'POST',
      fields: this.coursesFormFields,
      name: 'curso',
      createButtonTitle: 'Agregar curso',
      cols: 2,
      createApiSlug: `/product/assign-course/${this.productId}`, // This endpoint needs to be created in the backend
      formTitle: 'Agregar Curso',
      formButtonTitle: 'Agregar',
      width: '3xl'
    };

    this.coursesCRUD = {
      genericTable: {
        columns: this.coursesTableColumns,
        actions: this.coursesTableActions,
        items: [],
        loadItemsSlug: `/product/courses/${this.productId}`,
        type: 'generic',
        paginate: true,
        name: 'Cursos del Producto',
        details: false
      },
      genericForm: coursesForm,
      useModalForm: true
    };
  }


  toggleActiveProductForm(): void {
    this.activeProductForm = !this.activeProductForm;
  }

  onFinishProductForm(): void {
    this.toggleActiveProductForm();
    if (this.productId) {
      this.loadProductData();
    }
  }

  onFinishForm(): void {
    // Recargar datos del producto después de agregar un examen
    if (this.productId) {
      this.loadProductData();
    }
  }
}
